var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.97913 3.64645C9.17439 3.45118 9.49097 3.45118 9.68623 3.64645L13.6862 7.64645C13.8815 7.84171 13.8815 8.15829 13.6862 8.35355L9.68623 12.3536C9.49097 12.5488 9.17439 12.5488 8.97913 12.3536C8.78387 12.1583 8.78387 11.8417 8.97913 11.6464L12.1256 8.5H2.66602C2.38987 8.5 2.16602 8.27614 2.16602 8C2.16602 7.72386 2.38987 7.5 2.66602 7.5H12.1256L8.97913 4.35355C8.78387 4.15829 8.78387 3.84171 8.97913 3.64645Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.fab291148a11173c4529d662bf89b3e7.svg";
export { ForwardRef as ReactComponent };